"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryGoalToJSON = exports.DeliveryGoalFromJSONTyped = exports.DeliveryGoalFromJSON = exports.DeliveryGoal = void 0;
/**
 * The delivery goal for the ad set.
 * @export
 */
exports.DeliveryGoal = {
    Unset: 'UNSET',
    Impressions: 'IMPRESSIONS',
    Reach: 'REACH',
    VideoViews: 'VIDEO_VIEWS',
    Clicks: 'CLICKS',
    PageViews: 'PAGE_VIEWS',
    AppInstalls: 'APP_INSTALLS',
    Streams: 'STREAMS'
};
function DeliveryGoalFromJSON(json) {
    return DeliveryGoalFromJSONTyped(json, false);
}
exports.DeliveryGoalFromJSON = DeliveryGoalFromJSON;
function DeliveryGoalFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DeliveryGoalFromJSONTyped = DeliveryGoalFromJSONTyped;
function DeliveryGoalToJSON(value) {
    return value;
}
exports.DeliveryGoalToJSON = DeliveryGoalToJSON;
